var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFilterBrand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "-459 261 40 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#424D56"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-441.3 269.8c-4-4.1-7.7-3.4-9.2-2.8-2.6 1-4.5 3.5-4.3 5.9.1.9.4 1.5 1 2 1.5 1.2 4.2.8 7.3.3 2.5-.4 5.2-.7 7-.2.4.1 1.1 0 1.2-.4.1-.4-.3-.9-.8-1.1-2.1-.6-5.1-.3-7.8.1-2.5.4-5.1.8-6 0-.2-.1-.4-.3-.4-.9-.1-1.7 1.3-3.6 3.3-4.3 2.4-.9 5-.1 7.3 2.2.3-.3.7-.6 1.1-.8h.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-437.7 295.1l-6.4-12.6c-.5-.9 0-3.2.3-5.3.1-.5.2-1.2.3-1.8 1.5-.1 3-.1 4 .2.7.2 1.3-.4 1.5-.9.4-1.1-.2-1.7-.6-1.8-1.3-.4-2.8-.4-4.3-.3.1-.4.1-.6.1-.6.2-.7.9-1.4 1.7-1.7.6-.3 1.2-.4 2-.3.1 0 .2 0 .3.1l3.1 1.4c.5.3 1.1.6 1.6.8 1.9 1 4 2 4.4 2.9l6.4 12.6c.3.6.3 1.5 0 2.2-.2.5-.5.9-.9 1.2l-9.9 5.1c-1.4.5-3.1-.1-3.6-1.2z"
  }))));
}

export default SvgFilterBrand;